export default "__VITE_ASSET__C5vMwk0d__"